import styled from "@emotion/styled"

const AuthorInfo = styled.div`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-bottom: 30px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    margin-bottom: 40px;
  }
`

export default AuthorInfo
